// layouts

import Marketing from "../layouts/Marketing.vue";

// all routes need names for us to properly push page transitions to PostHog
const routes = [
  {
    name: "Marketing",
    path: "/",
    component: Marketing,
    children: [
      {
        name: "Home",
        path: "/",
        component: () => import("../views/Home.vue"),
      },
      {
        name: "Terms",
        path: "/terms",
        component: () => import("../views/Terms.vue"),
      },
      {
        name: "Privacy",
        path: "/privacy",
        component: () => import("../views/Privacy.vue"),
      },
      {
        name: "CSV RAG",
        path: "/csvrag",
        component: () => import("../views/Csvrag.vue"),
      }
    ],
  },
  { name: "GeneralRedirect", path: "/:pathMatch(.*)*", redirect: "/" },
];

export default routes;
